module.exports = __webpack_public_path__ + "static/media/oel_logo_paywall.a191daa7.png";